
const addItemToCar = ({ commit } , payload) => {
  commit('addItemToCar', payload)
}

const removeItemFromCar = ({ commit } , payload) => {
  commit('removeItemFromCar', payload)
}

const cleanCar = ({ commit } ) => {
  commit('cleanCar')
}

const setStorageMode = ({ commit }, mode) => {
  commit('setStorageMode', mode);
};

export default {
  addItemToCar,
  removeItemFromCar,
  cleanCar,
  setStorageMode,
};



// WEBPACK FOOTER //
// ./src/store/modules/car/actions.js